import { useEffect, useState } from "react";

/**
 * A boolean that turns on `delayMs` after `value` does and off at once: for layout that should
 * follow a sliding panel only once the panel has covered it.
 *
 * @param {boolean} value
 * @param {number} delayMs
 * @returns {boolean}
 */
export function useSettledFlag(value, delayMs) {
  const [settled, setSettled] = useState(value);
  useEffect(() => {
    // Off is immediate through the return below; the stored flag catches up on the next tick.
    const t = setTimeout(() => setSettled(value), value ? delayMs : 0);
    return () => clearTimeout(t);
  }, [value, delayMs]);
  return value && settled;
}
